import CryptoJS from "crypto-js";

export function extractErrorMessage(error) {
  return (
    (error.response && error.res.data && error.response.data.message) ||
    error.message ||
    error.toString()
  );
}

export function formatDate(date) {
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export const getEncryptedCaptcha = (captcha) => {
  // Get the current date
  const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format
  // Combine captchaCode with the date
  const datedCaptcha = captcha + currentDate;
  // Encrypt the saltedCaptcha using SHA-512
  const encryptedCaptcha = CryptoJS.SHA512(datedCaptcha).toString();
  return encryptedCaptcha;
};

//  get last 20 years

export const getLastNYears = (n = 20) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: n + 1 }, (_, i) => currentYear - i);
};
